import {Lang} from 'yougile-lang'
import {OptionsItem} from '@components/common/base/dropdown-button-menu/types'
import {RemoveAssignedOptions} from '../types'

export const getRemoveAssignedOptions = (
  selected?: RemoveAssignedOptions
): OptionsItem[] => {
  const lang = Lang.msg.movementTemplates

  const options: {
    key: RemoveAssignedOptions
    text: string
    selected: boolean
  }[] = [
    {
      key: 'all-current',
      text: lang.optionAllCurrent,
      selected: 'all-current' === selected
    },
    {
      key: 'all-current-except-yourself',
      text: lang.optionAllCurrentExceptYourself,
      selected: 'all-current-except-yourself' === selected
    },
    {
      key: 'specific-users',
      text: lang.optionSpecificUsers,
      selected: 'specific-users' === selected
    }
  ]

  return options
}
